/* eslint-disable */
import * as Types from '../../../../../../../../models/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type GetMainGrapeVariablesDTO = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type GetMainGrapeDTO = (
  { __typename?: 'Query' }
  & { mainGrape: (
    { __typename?: 'MainGrape' }
    & Pick<Types.MainGrapeDTO, 'id' | 'name' | 'wineStyle' | 'archived'>
    & { temperatureDescriptions?: Types.Maybe<Array<(
      { __typename?: 'MultiLanguageText' }
      & Pick<Types.MultiLanguageTextDTO, 'language' | 'text'>
    )>>, foodDescriptions?: Types.Maybe<Array<(
      { __typename?: 'MultiLanguageText' }
      & Pick<Types.MultiLanguageTextDTO, 'language' | 'text'>
    )>> }
  ) }
);


export const GetMainGrapeDocumentDTO = gql`
    query getMainGrape($id: String!) {
  mainGrape(id: $id) {
    id
    name
    wineStyle
    archived
    temperatureDescriptions {
      language
      text
    }
    foodDescriptions {
      language
      text
    }
  }
}
    `;

/**
 * __useGetMainGrape__
 *
 * To run a query within a React component, call `useGetMainGrape` and pass it any options that fit your needs.
 * When your component renders, `useGetMainGrape` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMainGrape({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMainGrape(baseOptions: Apollo.QueryHookOptions<GetMainGrapeDTO, GetMainGrapeVariablesDTO>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMainGrapeDTO, GetMainGrapeVariablesDTO>(GetMainGrapeDocumentDTO, options);
      }
export function useGetMainGrapeLazyQueryDTO(baseOptions?: Apollo.LazyQueryHookOptions<GetMainGrapeDTO, GetMainGrapeVariablesDTO>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMainGrapeDTO, GetMainGrapeVariablesDTO>(GetMainGrapeDocumentDTO, options);
        }
export type GetMainGrapeHookResult = ReturnType<typeof useGetMainGrape>;
export type GetMainGrapeLazyQueryDTOHookResult = ReturnType<typeof useGetMainGrapeLazyQueryDTO>;
export type GetMainGrapeQueryResultDTO = Apollo.QueryResult<GetMainGrapeDTO, GetMainGrapeVariablesDTO>;